export enum SortType {
  asc = "asc",
  desc = "desc",
  default = "",
}

export interface SortEvent {
  column: string;
  sortType: SortType;
}
